module.exports = __webpack_public_path__ + "img/lainaaja.161783a.png";